module.exports = __webpack_public_path__ + "static/31-a7945eb942fa8ae7fc547b80de68fbc9.jpg";